import React, { useCallback } from 'react';
import { useRouter } from 'next/router';

import { LoadingBubble } from '@nakedplatform/ui';

import { Page } from 'components/page';
import { AppNavigator } from 'components/menu/navigator';
import { Container } from 'theme/layout';
import { Routes } from 'routes';
import dynamic from 'next/dynamic';

/**
 * A function which renders the loader component
 *
 * @returns Loader Component
 */
function Loader() {
  return (
    <Container
      pt={['30px', '120px']}
      mb={['40px', '10em']}
      mx={['auto']}
      display="flex"
      justifyContent="center"
    >
      <LoadingBubble loading={true} />
    </Container>
  );
}
const ChooseProductPageContents = dynamic(
  () => import('./components/index').then(m => m.ChooseProductPageContents),
  {
    loading: Loader,
  }
);

/**
 * Launch page from which the user can start quoting for multiple types of cover
 */
export function ChooseProductPage() {
  const router = useRouter();
  const { stage } = router.query;
  const backIsVisible = false;

  const goBack = useCallback(() => {
    router.back();
  }, [router]);

  const goHome = useCallback(() => {
    // Use assign (not replace) so the browser back button returns the user to
    // this page rather than skipping over it to wherever they came from.
    window.location.assign(Routes.HOME);
  }, [router, stage]);

  return (
    <Page name="quote">
      <AppNavigator
        centerAlign
        showSiteNav={false}
        goBack={goBack}
        goHome={goHome}
        isRose={true}
        showBackButton={backIsVisible}
      />
      <ChooseProductPageContents />
    </Page>
  );
}
